import { idToStrongId } from "@oysterhr/common"
import { companyBasePath } from "@oysterhr/router"
import { stringify } from "query-string"
import { generatePath } from "react-router-dom"
import { StepName } from "../../types"

const _preferencesTemplateBasePath = (templateId?: string, path?: string) =>
  generatePath("preferences/templates/:templateId/*", {
    templateId: idToStrongId(templateId || ""),
    "*": path || "",
  })

export const companyPreferencesPath = (companyId: string) => {
  return companyBasePath({ companyId, path: "preferences" })
}

export const companyPreferencesCreateHiringTemplatePath = (
  companyId: string,
  templateId?: string,
  query?: {
    name?: string
    description?: string
    type?: "global" | "country"
  },
) => {
  const qs = stringify(query || {}, { skipEmptyString: true })
  const path = templateId ? "draft" : "new"

  return companyBasePath({
    companyId,
    path: _preferencesTemplateBasePath(templateId, path),
    query: qs,
  })
}

export const companyPreferencesHiringTemplateDisplayPath = (
  companyId: string,
  templateId: string,
) =>
  companyBasePath({
    companyId,
    path: _preferencesTemplateBasePath(templateId, "details"),
  })

export const companyPreferencesHiringTemplateEditPath = (
  companyId: string,
  templateId: string,
  stepName: StepName,
) =>
  companyBasePath({
    companyId,
    path: _preferencesTemplateBasePath(templateId, `edit/${stepName}`),
  })
